(function() {
  function initTabs(section) {
    var tabs = section.querySelectorAll('.tbhip-tab');
    var panels = section.querySelectorAll('.tbhip-tab-panel');
    if (!tabs.length) return;
    function activate(index) {
      tabs.forEach(function(t, i) {
        var active = i === index;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
        t.tabIndex = active ? 0 : -1;
        if (panels[i]) {
          panels[i].classList.toggle('is-active', active);
        }
      });
    }
    tabs.forEach(function(tab, index) {
      tab.addEventListener('click', function() { activate(index); });
      tab.addEventListener('keydown', function(e) {
        if (e.key === 'ArrowRight') { activate((index + 1) % tabs.length); tabs[(index + 1) % tabs.length].focus(); }
        if (e.key === 'ArrowLeft') { activate((index - 1 + tabs.length) % tabs.length); tabs[(index - 1 + tabs.length) % tabs.length].focus(); }
      });
    });
  }

  document.addEventListener('shopify:section:load', function(e) {
    var section = e.target;
    if (section && section.matches('.tbhip-marketplace')) initTabs(section);
  });
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.tbhip-marketplace').forEach(initTabs);
  });
})();
